
  <div class="row" #myDiv >
    <div class="col-lg-12">
      <div class="navbar-center row">
  
  
        <div class="col">
          <div class="row position-absolute flex-nowrap" style="right: 0px">
            <div class="col text-nowrap text-right mt-2">
              <p >{{'languages.listing.label_goto' | translate}}</p>
            </div>
            <div class="col mt-1 ml-2">
              <input [(ngModel)]="intervale" size="1" min="1" onkeypress="return event.charCode >= 48"
                (keyup.enter)="getchangeLimite()" (change)="getchangeLimite()" type="number" style="margin-left: 4px;"
                size="1" class="page_input bg-white border rounded font-weight-bold" [value]="pages" max="{{totalPages}}">
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-4 border-0 border" >
        <div class="row d-flex justify-content-center align-items-center background-style">
            <div class="col-3">
                
                <button  type="button" class="btn-dt-exporter" (click)="exportDataToCsv()" [disabled]="logs?.length==0"   [ngStyle]="{'opacity': logs?.length==0 ? '0.5' : '1'}">
                    <i class="fa-solid fa-file-excel fa-lg"></i>
                           {{'languages.buttons.exporterCSV' | translate}}
                </button>
            </div>
          <div class="col-6 blocDate mt-2">
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-2">    
                  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28.4162 5.93325V3.33325C28.4162 2.64992 27.8495 2.08325 27.1662 2.08325C26.4828 2.08325 25.9162 2.64992 25.9162 3.33325V5.83325H15.0828V3.33325C15.0828 2.64992 14.5162 2.08325 13.8328 2.08325C13.1495 2.08325 12.5828 2.64992 12.5828 3.33325V5.93325C8.08282 6.34992 5.89949 9.03325 5.56615 13.0166C5.53282 13.4999 5.93282 13.8999 6.39949 13.8999H34.5995C35.0828 13.8999 35.4828 13.4833 35.4328 13.0166C35.0995 9.03325 32.9162 6.34992 28.4162 5.93325Z" fill="#0F1D64"/>
                    <path opacity="0.4" d="M35.4995 18.0632V20.9632C35.4995 21.9799 34.5995 22.7632 33.5995 22.5965C33.1328 22.5299 32.6495 22.4799 32.1662 22.4799C29.7364 22.4843 27.4074 23.4515 25.6892 25.1696C23.9711 26.8877 23.0039 29.2168 22.9995 31.6466C22.9995 32.4132 23.2995 33.4799 23.6162 34.4465C23.7018 34.6976 23.7261 34.9655 23.687 35.2279C23.648 35.4903 23.5468 35.7396 23.3919 35.9549C23.2369 36.1702 23.0327 36.3453 22.7963 36.4656C22.5599 36.5859 22.2981 36.648 22.0328 36.6466H13.8328C7.99951 36.6466 5.49951 33.3132 5.49951 28.3132V18.0465C5.49951 17.1299 6.24951 16.3799 7.16618 16.3799H33.8328C34.7495 16.3965 35.4995 17.1465 35.4995 18.0632Z" fill="#0F1D64"/>
                    <path d="M32.1662 25.0001C28.4828 25.0001 25.4995 27.9834 25.4995 31.6667C25.4995 32.9167 25.8495 34.1001 26.4662 35.1001C27.0537 36.0876 27.8883 36.905 28.8878 37.472C29.8872 38.0389 31.0171 38.3358 32.1662 38.3334C34.5995 38.3334 36.7162 37.0334 37.8662 35.1001C38.4828 34.1001 38.8328 32.9167 38.8328 31.6667C38.8328 27.9834 35.8495 25.0001 32.1662 25.0001ZM35.6162 30.9501L32.0662 34.2334C31.8328 34.4501 31.5162 34.5667 31.2162 34.5667C30.8995 34.5667 30.5828 34.4501 30.3328 34.2001L28.6828 32.5501C28.4504 32.3149 28.32 31.9975 28.32 31.6667C28.32 31.336 28.4504 31.0186 28.6828 30.7834C29.1662 30.3001 29.9662 30.3001 30.4495 30.7834L31.2495 31.5834L33.9162 29.1167C34.4162 28.6501 35.2162 28.6834 35.6828 29.1834C36.1495 29.6834 36.1162 30.4667 35.6162 30.9501ZM14.6662 25.0001C14.2328 25.0001 13.7995 24.8168 13.4828 24.5168C13.1828 24.2001 12.9995 23.7668 12.9995 23.3334C12.9995 22.9001 13.1828 22.4668 13.4828 22.1501C13.8662 21.7668 14.4495 21.5834 14.9995 21.7001C15.0995 21.7168 15.1995 21.7501 15.2995 21.8001C15.3995 21.8334 15.4995 21.8834 15.5995 21.9501L15.8495 22.1501C16.1495 22.4668 16.3328 22.9001 16.3328 23.3334C16.3328 23.7668 16.1495 24.2001 15.8495 24.5168L15.5995 24.7168C15.4995 24.7834 15.3995 24.8334 15.2995 24.8668C15.1995 24.9168 15.0995 24.9501 14.9995 24.9667C14.8828 24.9834 14.7662 25.0001 14.6662 25.0001ZM20.4995 25.0001C20.0662 25.0001 19.6328 24.8168 19.3162 24.5168C19.0162 24.2001 18.8328 23.7668 18.8328 23.3334C18.8328 22.9001 19.0162 22.4668 19.3162 22.1501C19.9495 21.5334 21.0662 21.5334 21.6828 22.1501C21.9828 22.4668 22.1662 22.9001 22.1662 23.3334C22.1662 23.7668 21.9828 24.2001 21.6828 24.5168C21.3662 24.8168 20.9328 25.0001 20.4995 25.0001ZM14.6662 30.8318C14.2328 30.8318 13.7995 30.6484 13.4828 30.3484C13.1828 30.0317 12.9995 29.5984 12.9995 29.1651C12.9995 28.7318 13.1828 28.2984 13.4828 27.9817C13.6495 27.8317 13.8162 27.7151 14.0328 27.6318C14.6495 27.3651 15.3828 27.5151 15.8495 27.9817C16.1495 28.2984 16.3328 28.7318 16.3328 29.1651C16.3328 29.5984 16.1495 30.0317 15.8495 30.3484C15.5328 30.6484 15.0995 30.8318 14.6662 30.8318Z" fill="#0F1D64"/>
                    </svg>
                              </div>
              <div class="col-8">
              
                    <mat-form-field appearance="standard" class="w-100">
                      <mat-date-range-input [rangePicker]="picker"  >
                        <input matStartDate [(ngModel)]="date_debut" readonly placeholder="Date début "  (click)="openDatePicker()" />
                        <input matEndDate [(ngModel)]="date_fin" readonly placeholder="Date fin" (click)="openDatePicker()"/>
                        
                      </mat-date-range-input>
                      
                      <mat-datepicker-toggle class="m-0 p-0" matPrefix [for]="picker">    <mat-icon matDatepickerToggleIcon>
                        <img src="assets/icons/calendar.svg" > 
                      </mat-icon></mat-datepicker-toggle>
                      <img  class="remouveDate" matSuffix (click)="clearDateCreation()" src="assets/icons/delete-left.svg">
                      <mat-date-range-picker  [calendarHeaderComponent]="rangeDateCreation" #picker></mat-date-range-picker>
                    </mat-form-field>
                 
                </div>
                <div class="col-2 w-100 pl-0 ">
                    <button type="button" class="filtrer" (click)=" filtrer()">
                      <img src="assets/icons/filtre.svg" class="mr-3" alt=""> 
                      <p class="m-0" style="font-size: 14px;">{{'languages.buttons.filtrer' | translate}}</p>
      </button>
                </div>
            </div>
        </div>
          <div class="col-3 p-2  text-right">
            <input class="search" name="search" [(ngModel)]="search"  (input)="onInputChange($event.target.value)" placeholder="{{'languages.miniListing.search' | translate}}">
            <i aria-hidden="true" class="fa-solid fa-magnifying-glass icon-search fa-md"></i>
          </div>
          
        </div>
        
        <div class="table-responsive p-3">
          <table class="table align-items-center">
            <thead class="head-table">
              <tr>
                <th>
                  {{'languages.listing.event' | translate}}
                </th>
                <th>
                    {{'languages.listing.dateExecution' | translate}}
                  </th>
                  <th>
                    {{'languages.listing.idRule' | translate}}
                  </th>

                <th >
                  {{'languages.convention.status' | translate}}
                </th>
                <th >{{'languages.opportunite.source' | translate}}
                
                </th>
                
                  <th>
                    {{'languages.listing.msg' | translate}}
                  </th>
                  <th>

                    {{'languages.listing.actions' | translate}}
                  </th>
                
              </tr>
            </thead>
            <tbody class="body-table">
              <tr *ngFor="let log of logs; let i = index">
                <td>
                    <p [title]="log?.source_event" >{{expandFileName(log?.source_event)}}</p>
                  </td>
                  <td>
                    <p>{{log?.last_execution}}</p>
                  </td>
                <td>
                  <p [title]="log?.name_rule">{{log?.id_rule}}</p>
                </td>
                <td class="d-flex align-items-center justify-content-center">
                  <div [ngClass]="{'ok-class': log.status === 'OK', 'ko-class': log.status === 'KO'}">
                    <p>{{log.status}}</p>
                  </div>
                 
                </td>
                <td>
                  <i *ngIf="log?.id_entity" (click)="getPageSource(log?.entity,log?.id_entity)" class="fa-solid fa-link fa-icon-style linkPageSource"></i>
                  
                </td>
                <td>
                  <p [title]="log?.msg">{{expandFileName(log?.msg)}}</p>
                </td>
                <td>
  
                 <div class="row d-flex justify-content-end align-items-center pr-2">
                  <button class="reexecute" *ngIf="log?.status === 'KO' && !log.isLoading" (click)="Reexecute(log)">
                    <i [title]="'languages.listing.reexecuteevent' | translate" class="fa-solid fa-arrows-rotate-reverse fa-lg"></i>
                  </button>
                  
                  <ng-container *ngIf="log.isLoading">
                    <div class="">
                        <div class="text-center m-auto ">
                            <mat-spinner [diameter]="20"></mat-spinner>
        
                        </div>
                    </div>
                </ng-container>
                    
                    <button class="downloadJson "  (click)="downloadJson(log)">
                        <i [title]="'languages.listing.downloadJson' | translate" class="fa-solid fa-download fa-lg"></i>
                    </button>
                 </div>
            </td>
              </tr>
            </tbody>
          </table>
          <div class="row d-flex justify-center align-items-center text-center ">
            <p *ngIf="logs?.length===0"  class="col-12 noTicket">  {{'languages.affaire.noDataAvailable' | translate}} </p>
           </div>
        </div>
      </div>
      <div class="navbar-center mb-4 row">
        <div class="col pt-1">
          <div class="row w-50 flex-nowrap" >
            <div  class="col mt-1">
              <p>{{'languages.miniListing.Afficher' | translate}}</p>
            </div>
            <div class="col mx-1">
              <select [(ngModel)]="limit" (change)="updateListTickets()"
                class="bg-white border pt-1 rounded font-weight-bold">
                <option value="15">15</option>
                <option value="25">25</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div class="col mt-1">
              <p class="text-nowrap">{{'languages.miniListing.pagesPerPage' | translate}} {{totalLength}} {{'languages.miniListing.element' | translate}}</p>
            </div>
          </div>
        </div>
        <div class="col-8">
          <nav aria-label="Page navigation example" *ngIf="totalPages>0">
            <ul class="pagination pg-blue">
              <li (click)="first()" class="page-item" [ngClass]="{'disabled':isFirst()}">
                <a class="page-link-symbol">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li *ngIf="!isFirst()" (click)="prev()" class="page-item mx-2">
                <a class="page-link-symbol-chevron" aria-label="Previous">
                  <i class="fa fa-chevron-left "></i>
                </a>
              </li>
              <ng-container *ngFor="let item of [].constructor(3); let i = index">
                <li *ngIf="i+pages-3>0" class="page-item">
                  <a (click)="changepage(i+pages-3)" class="page-link mt-2 border rounded">{{i + pages - 3}}</a>
                </li>
              </ng-container>
              <ng-container *ngFor="let item of [].constructor(3); let i = index">
                <li *ngIf="i+pages<totalPages" class="page-item">
                  <a (click)="changepage(i+pages)" class="page-link mt-2 border rounded"
                    [ngClass]="{'active-page':pages==(i+pages)}">
                    {{i + pages}}
                  </a>
                </li>
              </ng-container>
              <li *ngIf="totalPages>1 && totalPages > 3 " class="m-2"> ... </li>
              <li class="page-item">
                <a (click)="changepage(totalPages)" class="page-link mt-2 border rounded"
                  [ngClass]="{'active-page':pages==totalPages}">{{totalPages}}</a>
              </li>
              <li *ngIf="!isLast()" (click)="next()" class="page-item mx-2">
                <a class="page-link-symbol-chevron" aria-label="Next">
                  <i class="fa fa-chevron-right"></i>
                </a>
              </li>
              <li (click)="last()" class="page-item" [ngClass]="{'disabled':isLast()}">
                <a class="page-link-symbol">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col">
          <div class="row position-absolute flex-nowrap" style="right: 0px">
            <div class="col text-nowrap text-right mt-2">
              <p >{{'languages.listing.label_goto' | translate}}</p>
            </div>
            <div class="col mt-1 ml-2">
              <input [(ngModel)]="intervale" size="1" min="1" onkeypress="return event.charCode >= 48"
                (keyup.enter)="getchangeLimite()" (change)="getchangeLimite()" type="number" style="margin-left: 4px;"
                size="1" class="page_input bg-white border rounded font-weight-bold" [value]="pages" max="{{totalPages}}">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  